import { StatusBanner } from "../StatusBanner/StatusBanner";

const MintError: React.FC<{
  error: any;
  mintData: any;
  transactionUrl: string;
  show: boolean;
}> = ({ error, mintData, transactionUrl, show }) => (
  <StatusBanner title="Transaction Error" show={show}>
    {error.call === "premint" && (
      <>
        We did not attempt your transaction.<br></br> It was expected to fail
        with the message: <b className="text-coinage-blue">{error.message}</b>{" "}
        <br />
        If you think this is incorrect reach out to{" "}
        <a
          className="text-coinage-blue underline"
          href="mailto:contact@trustless.media">
          contact@trustless.media
        </a>
        {mintData?.hash && (
          <a
            className="text-coinage-blue underline"
            href={transactionUrl}
            target="_blank"
            rel="noreferrer">
            View transaction
          </a>
        )}
      </>
    )}
    {error.call === "mint" && (
      <>
        Sorry your transaction failed with the message:
        <b className="text-coinage-blue"> {error.message}</b> <br />
        <a
          className="text-coinage-blue underline"
          href={transactionUrl}
          target="_blank"
          rel="noreferrer">
          View transaction
        </a>
        <br></br>
        If you think this is incorrect reach out to{" "}
        <a
          className="text-coinage-blue underline"
          href="mailto:contact@trustless.media">
          contact@trustless.media
        </a>{" "}
        and include the transaction URL
      </>
    )}
    {error.call === "unknown" && (
      <>
        Sorry your transaction failed please try again or reach out to{" "}
        <a
          className="text-coinage-blue underline"
          href="mailto:contact@trustless.media">
          contact@trustless.media
        </a>
      </>
    )}
  </StatusBanner>
);

export default MintError;
